import React from "react";
const TimeframeFilter = (props) => {
    const { name, value, onChange } = props;
    return (React.createElement("div", { className: "d-flex" },
        React.createElement("div", { className: "form-check w-100" },
            React.createElement("input", { className: "form-check-input", type: "radio", name: name, id: "alltime", value: "alltime", onChange: onChange, checked: value === "alltime" }),
            React.createElement("label", { className: "form-check-label m-0", htmlFor: "alltime" }, "All Time")),
        React.createElement("div", { className: "form-check w-100" },
            React.createElement("input", { className: "form-check-input", type: "radio", name: name, id: "week", value: "week", onChange: onChange, checked: value === "week" }),
            React.createElement("label", { className: "form-check-label m-0", htmlFor: "week" }, "Weekly")),
        React.createElement("div", { className: "form-check w-100" },
            React.createElement("input", { className: "form-check-input", type: "radio", name: name, id: "month", value: "month", onChange: onChange, checked: value === "month" }),
            React.createElement("label", { className: "form-check-label m-0", htmlFor: "month" }, "Monthly"))));
};
export default TimeframeFilter;
